// @flow

import * as React from 'react';
import {Handle, Position} from 'react-flow-renderer';

import {range} from 'lodash';
import Box from 'sail/Box';
import {Heading} from 'sail/Text';
import './SequenceDiagram.scss';
import {useSequenceDiagram} from 'docs/data/diagram';
import {SequenceDiagramGeneratorHandle} from '../Handles';

// TODO(adreyfus): Remove these hardcoded values when we update docs Sail colors
const COLORS = ['#3EA50B', '#FF8F0E', '#0055BC', '#635BFF', '#000'];

type SequenceDiagramActorNodeSectionProps = {|
  id: string,
  index: number,
  height: number,
  color: ?string,
|};

const SequenceDiagramActorNodeSection = ({
  id,
  index,
  color,
  height,
}: SequenceDiagramActorNodeSectionProps) => {
  const handleStyles = {top: '100%'};
  return (
    <Box
      className="SequenceDiagramActorNode-section"
      style={{height: `${height * 100}%`}}
    >
      {color && (
        <Box
          className="SequenceDiagramActorNode-section-highlight"
          style={{
            backgroundColor: color,
          }}
        />
      )}
      <Handle
        type="target"
        id={`${id}-${index}-left`}
        position={Position.Left}
        style={handleStyles}
      />
      <Handle
        type="source"
        position={Position.Left}
        id={`${id}-${index}-left`}
        style={handleStyles}
      />
      <Handle
        type="target"
        id={`${id}-${index}-right`}
        position={Position.Right}
        style={handleStyles}
      />
      <Handle
        type="source"
        position={Position.Right}
        id={`${id}-${index}-right`}
        style={handleStyles}
      />
    </Box>
  );
};

type SequenceDiagramActorNodeData = {|
  heading: React.Node,
  index: number,
  rows: number,
  highlights: Array<number>,
|};

type SequenceDiagramActorNodeProps = {|
  id: string,
  data: SequenceDiagramActorNodeData,
|};

export const SequenceDiagramActorNode = ({
  id,
  data,
}: SequenceDiagramActorNodeProps) => {
  const {heading, index, highlights, rows} = data;
  let {height} = useSequenceDiagram();
  if (!height) {
    height = 60;
  }
  // Add one to the total number of rows so we have some visual bottom padding on the diagram
  const sections = rows + 1;
  return (
    <Box
      className="SequenceDiagramActorNode"
      style={{height: `${height * 1.5 * sections}px`}}
    >
      <Box
        flex={{alignItems: 'center'}}
        className="SequenceDiagramActorNode-heading"
      >
        <Box
          className="SequenceDiagramActorNode-heading-highlight"
          style={{
            background: `${COLORS[index] || 'black'}`,
          }}
        />
        <Heading>{React.Children.toArray(heading)}</Heading>
      </Box>
      <SequenceDiagramGeneratorHandle top="12%" translateX={3} />
      {range(1, sections + 1).map((i) => (
        <SequenceDiagramActorNodeSection
          key={`SequenceDiagramActorNodeSection-${i}`}
          id={id}
          index={i}
          height={1 / sections}
          color={highlights && highlights.includes(i) ? COLORS[index] : null}
        />
      ))}
    </Box>
  );
};
